import React from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import Base from '../Select'

export const GET_MANUFACTURERS = gql`
  {
    manufacturers {
      id
      name
    }
  }
`

const Select = ({...others}) => {
  return (
    <Query query={GET_MANUFACTURERS} fetchPolicy='cache-and-network'>
      {({data}) =>
        <Base
          options={!data || !data.manufacturers
            ? []
            : data.manufacturers.map(m => ({key: m.id, label: m.name, value: m.id}))}
          {...others}
        />
      }
    </Query>
  )
}

export default Select


// WEBPACK FOOTER //
// ./src/components/Manufacturers/Select.js